import React, { useMemo } from 'react';
import FabricationPavementSelect from '../../../../../../components/FabricationPavementsSelect/indexFacelift';
import { EProjectStructure } from '../../../../../../store/ducks/fabrication-projects/types';
import {
  NewProjectRowContainer,
  SendProjectContent,
  DataInputContainer
} from './styles';
import { Select, TextField } from '@gerdau/hefesto';
import { TSelectOptionProps } from '@gerdau/hefesto/Select/Select.types';
import {
  IFabricationMockupsState,
  IPavementData
} from '../../../../../../store/ducks/fabrication-mockups/types';
import { projectPavementsNeedRange } from '../../../../../../utils/fabricationHelper';

export interface IEditProjectForm {
  mockupId?: number;
  structures?: string[];
  pavements?: number[];
  revision?: string;
}

interface IprojectFormProps {
  projectForm: IEditProjectForm;
  mockupState: IFabricationMockupsState;
  updateProjectform: (updatedForm: IEditProjectForm) => void;
  canUpdateFields: boolean;
}

const EditProjectForm: React.FC<IprojectFormProps> = ({
  projectForm,
  mockupState,
  updateProjectform,
  canUpdateFields
}) => {
  const selectedMockup = mockupState.mockups.find(
    (m) => m.id === projectForm.mockupId
  );

  const mockupOptions: TSelectOptionProps[] = useMemo(() => {
    return mockupState.mockups.map((pm) => ({
      label: pm.name,
      value: pm.id.toString()
    }));
  }, [mockupState.mockups]);

  const structureOptions: TSelectOptionProps[] = useMemo(() => {
    return Object.values(EProjectStructure).map((structure) => ({
      label: structure,
      value: structure
    }));
  }, [EProjectStructure]);

  const pavementOptions: IPavementData[] = useMemo(() => {
    return (
      selectedMockup?.pavements
        .sort((a, b) => b.position - a.position)
        .map((p) => ({ ...p, id: p.id as number })) || []
    );
  }, [selectedMockup?.pavements]);

  return (
    <SendProjectContent>
      <NewProjectRowContainer>
        <DataInputContainer>
          <Select
            placeholder="Selecione a maquete"
            label="*Maquete"
            name="mockupSelect"
            options={mockupOptions}
            value={projectForm.mockupId?.toString() ?? ''}
            onSelect={(newValue) => {
              updateProjectform({
                ...projectForm,
                mockupId: Number(newValue),
                pavements: []
              });
            }}
            disabled={!canUpdateFields || mockupState.loading}
          ></Select>
        </DataInputContainer>

        <DataInputContainer>
          <Select
            placeholder="Indique a estrutura do projeto"
            label="*Estrutura do projeto"
            name="structureSelect"
            options={structureOptions}
            isMultipleSelect
            value={projectForm.structures ?? []}
            onSelect={(newValue) =>
              updateProjectform({
                ...projectForm,
                structures: newValue as string[],
                pavements: []
              })
            }
            disabled={!canUpdateFields}
          ></Select>
        </DataInputContainer>
      </NewProjectRowContainer>

      <NewProjectRowContainer>
        <DataInputContainer>
          <FabricationPavementSelect
            label="*Pavimento"
            onChange={(newValue) =>
              updateProjectform({ ...projectForm, pavements: newValue })
            }
            pavements={projectForm.pavements || []}
            pavementsOptions={pavementOptions}
            isPavementRangeNeeded={projectPavementsNeedRange(
              projectForm.structures || []
            )}
            disabled={
              !canUpdateFields ||
              !selectedMockup ||
              !projectForm.structures ||
              projectForm.structures?.length === 0
            }
          />
        </DataInputContainer>

        <DataInputContainer>
          <TextField
            label="*Revisão do projeto"
            name="revisionNumberProjectInput"
            value={projectForm.revision ?? ''}
            onChange={(e) => {
              updateProjectform({ ...projectForm, revision: e.target.value });
            }}
            disabled={!canUpdateFields}
            placeholder="Preencha a revisão do projeto"
          />
        </DataInputContainer>
      </NewProjectRowContainer>
    </SendProjectContent>
  );
};
export default EditProjectForm;
